import styled from 'styled-components/macro';
import { BrandOverline } from '@yme/atoms/brand-overline';
import { BG_GRADIENT_FROM_WHITE_TO_TRANSPARENT } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { Z_INDEX } from '@yme/tokens/zindex';
export const FlexWrapperStyled = styled(FlexWrapper) `
  position: relative;
  width: 100%;
  flex-basis: 100%;
`;
export const BrandOverlineStyled = styled(BrandOverline) `
  max-width: 1440px;
  z-index: ${Z_INDEX.level1};
  flex-basis: 100%;

  background-image: ${BG_GRADIENT_FROM_WHITE_TO_TRANSPARENT};

  ${ADAPTIVE.minWidth.desktop} {
    margin: -48px 48px 0;
  }
`;
export const PaddingBlockStyled = styled.div `
  padding-top: 24px;

  ${ADAPTIVE.minWidth.desktop} {
    padding-top: 48px;
  }
`;
